"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface MOCTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  {
    id: "MOC-1",
    question: "In responding to the identified risks of management override of controls, have we determined whether, in order to respond to the identified risks of management override of controls we need to perform other audit procedures in addition to the required procedures (journal entries, bias in accounting estimates, and significant transactions that are outside the normal course of business or that otherwise appear to be unusual)?\nIf Yes, please create necessary custom RoMMs, provide appropriate assessment(s) of inherent risk, and plan to perform further audit procedures to address the custom RoMMs.",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "MOC-2",
    question: "Do the entity's financial statements have \"top-side\" and/or \"post-close\" entries?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "MOC-3",
    question: "Are there any significant transactions that are outside the normal course of business or transactions that otherwise appear to be unusual?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "No",
      id: "MOC-3-document",
      question: "Please document:",
      type: "document",
    },
  },
  {
    id: "MOC-4",
    question: "Are there any financial statement level RoMMs identified apart from management override of controls?\nIf Yes, please create necessary custom RoMMs, provide appropriate assessment(s) of inherent risk, and plan to perform further audit procedures to address the custom RoMMs.",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export default function MOCTailoringQuestions({ onBack }: MOCTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Management Override of Controls"
      title="Management Override of Controls - Tailoring Questions"
      description="Customize the audit program for Management Override of Controls"
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}
